import { render, staticRenderFns } from "./ModalProceed.vue?vue&type=template&id=270ec708&scoped=true"
import script from "./ModalProceed.vue?vue&type=script&lang=js"
export * from "./ModalProceed.vue?vue&type=script&lang=js"
import style0 from "./ModalProceed.vue?vue&type=style&index=0&id=270ec708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270ec708",
  null
  
)

export default component.exports